import { render, staticRenderFns } from "./CarDelivery.vue?vue&type=template&id=6fb0de26&scoped=true&"
import script from "./CarDelivery.vue?vue&type=script&lang=js&"
export * from "./CarDelivery.vue?vue&type=script&lang=js&"
import style0 from "./CarDelivery.vue?vue&type=style&index=0&id=6fb0de26&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6fb0de26",
  null
  
)

export default component.exports